<template>
  <form class="login-form">
    <router-link tag="fieldset" to="/" class="wrap-top">
      <img src="../../../assets/logo.svg" alt="">
    </router-link>
    <fieldset class="wrap">
      <h1 v-if="!recovery"
          class="title font-semi-bold dark-blue-color">
        {{$t('login.title')}}
      </h1>
      <h1 v-else
          class="title font-semi-bold dark-blue-color">
        {{$t('login.recoveryTitle')}}
      </h1>
      <label class="input-cont" :class="{'error': $v.login.$error}">
        <div class="icon">
          <login-user></login-user>
        </div>
        <input type="text"
               v-model.trim="login"
               @blur="$v.login.$touch()"
               @focus="$v.login.$reset()"
               :placeholder="$t('forms.inputLoginPlaceholed')">
        <errors v-show="$v.login.$error" type="standart"></errors>
      </label>
      <label @mouseleave="hidePass"
             v-if="!recovery"
             :class="{'error': $v.pass.$error}"
             class="input-cont">
        <div class="icon">
          <login-pass></login-pass>
        </div>
        <input :type="password ? 'password' : 'text'"
               v-model.trim="pass"
               class="input-pass"
               @blur="$v.pass.$touch()"
               @focus="$v.pass.$reset()"
               :placeholder="$t('forms.passwordLabel')">
        <button type="button"
                @mousedown="showPass"
                @mouseup="hidePass"
                class="show-pass">
          <show-pass></show-pass>
        </button>
        <errors v-show="$v.pass.$error" type="standart"></errors>
      </label>
      <router-link v-if="!recovery"
                   to="recovery"
                   type="button"
                   class="forgot-password font-regular">{{$t('forms.restore')}}</router-link>
      <button type="submit"
              @click.prevent="loginAccount"
              :class="{'loading': loading}"
              :disabled="disableBtn || loading"
              v-if="!recovery"
              class="font-semi-bold btn-login btn btn-green">{{$t('btns.enter')}}</button>
      <button type="submit"
              @click.prevent="recoveryAccount"
              v-else
              :class="{'loading': loading}"
              :disabled="disableBtnRecovery || loading"
              class="font-semi-bold btn-login btn btn-green">{{$t('btns.send')}}</button>
      <div class="or-wrap" v-if="!recovery">
        <p class="or-label font-regular">{{$t('labels.or')}}</p>
      </div>
      <ul class="auth2-list" v-if="!recovery">
        <!--<li class="auth-item">-->
          <!--<button class="fb-btn" type="button">-->
            <!--<svg width="13" height="28" viewBox="0 0 13 28" fill="none" xmlns="http://www.w3.org/2000/svg">-->
              <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M8.60611 27.6995V14.0981H12.3607L12.8582 9.41104H8.60611L8.61249 7.06511C8.61249 5.84265 8.72864 5.18762 10.4845 5.18762H12.8317V0.5H9.07656C4.56609 0.5 2.97853 2.77374 2.97853 6.59746V9.41158H0.166992V14.0987H2.97853V27.6995H8.60611Z" fill="white"/>-->
            <!--</svg>-->
          <!--</button>-->
        <!--</li>-->
        <li class="auth-item">
          <button class="google-btn" type="button" @click="oAuthGoogle">
            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0005 4.35564C13.0348 4.35564 14.407 5.23434 15.1894 5.9686L18.2468 2.98341C16.3691 1.23804 13.9255 0.166748 11.0005 0.166748C6.76349 0.166748 3.10424 2.59823 1.32275 6.13712L4.82553 8.85749C5.70424 6.24545 8.13572 4.35564 11.0005 4.35564Z" fill="#EA4335"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M21.4005 11.2408C21.4005 10.3501 21.3283 9.70008 21.1718 9.026H11.0005V13.0464H16.9709C16.8505 14.0454 16.2005 15.5501 14.756 16.5612L18.1746 19.2093C20.2209 17.3195 21.4005 14.539 21.4005 11.2408Z" fill="#4285F4"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M4.83736 13.1426C4.60866 12.4686 4.47625 11.7463 4.47625 11C4.47625 10.2538 4.60866 9.53153 4.82533 8.85746L1.32255 6.13708C0.588289 7.6056 0.166992 9.25468 0.166992 11C0.166992 12.7454 0.588289 14.3945 1.32255 15.863L4.83736 13.1426Z" fill="#FBBC05"/>
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0002 21.8334C13.9252 21.8334 16.3808 20.8705 18.1743 19.2094L14.7558 16.5612C13.841 17.1992 12.6132 17.6446 11.0002 17.6446C8.1354 17.6446 5.70392 15.7547 4.83725 13.1427L1.33447 15.8631C3.11595 19.402 6.76318 21.8334 11.0002 21.8334Z" fill="#34A853"/>
            </svg>
            {{$t('forms.logInGoogle')}}
          </button>
        </li>
        <!--<li class="auth-item">-->
          <!--<button  type="button" class="mail-btn">-->
            <!--<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">-->
              <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M20.1807 14.863C20.01 11.5458 17.5483 9.55135 14.5749 9.55135H14.463C11.0319 9.55135 9.12883 12.2496 9.12883 15.3144C9.12883 18.7467 11.4312 20.9143 14.4496 20.9143C17.8153 20.9143 20.0285 18.4491 20.1886 15.5332L20.1807 14.863ZM14.4799 6.58387C16.7725 6.58387 18.9278 7.59708 20.5107 9.18353V9.18983C20.5107 8.42776 21.0232 7.85373 21.7352 7.85373L21.915 7.85255C23.0287 7.85255 23.257 8.90637 23.257 9.2399L23.2625 21.0846C23.1841 21.8593 24.0629 22.2595 24.5501 21.7627C26.452 19.8081 28.7272 11.715 23.3678 7.02542C18.3727 2.65363 11.6709 3.37431 8.10653 5.83086C4.31743 8.44431 1.89282 14.2275 4.24805 19.6594C6.81538 25.5857 14.1622 27.352 18.5284 25.5901C20.7394 24.6975 21.7609 27.6867 19.4644 28.6628C15.9946 30.1416 6.33755 29.9926 1.82619 22.1779C-1.22172 16.9009 -1.05929 7.616 7.02433 2.80581C13.2085 -0.873692 21.3615 0.145435 26.2777 5.2801C31.4167 10.6474 31.1171 20.6979 26.1043 24.6076C23.8334 26.3821 20.4602 24.6541 20.4819 22.0671L20.4583 21.221C18.8769 22.7905 16.7725 23.706 14.4799 23.706C9.94963 23.706 5.96381 19.7198 5.96381 15.191C5.96381 10.6158 9.94963 6.58387 14.4799 6.58387Z" fill="#FFA930"/>-->
            <!--</svg>-->
          <!--</button>-->
        <!--</li>-->
      </ul>
    </fieldset>
  </form>
</template>

<script>
  import {mapMutations, mapActions} from 'vuex';
  import loginUser from '../../Svg/loginUser'
  import loginPass from '../../Svg/loginPass'
  import showPass from '../../Svg/showPass'
  import {required, minLength} from 'vuelidate/lib/validators'
  import errors from '../../Forms/errors'
  import {showOverlay} from "../../../mixins/utils/showOverlay";

  export default {
    name: 'loginForm',
    props: {
      recovery: {
        default: false,
        type: Boolean
      }
    },
    mixins: [showOverlay],
    components: {
      loginUser,
      loginPass,
      showPass,
      errors
    },
    data() {
      return {
        password: true,
        login: '',
        pass: '',
        loading: false,
      }
    },
    mounted() {
      if(this.$route.query.oauthprovider && this.$route.query.code) {
        let oauthprovider = this.$route.query.oauthprovider;
        let code = this.$route.query.code;
        this.oAuthLoginAccount(oauthprovider, code);
      }
    },
    validations: {
      login: {
        required,
      },
      pass: {
        required,
        minLength: minLength(4)
      }
    },
    methods: {
      ...mapMutations({
        showErrorLogin: 'popups/errorLogin/SHOW_ERROR_LOGIN',
        showRecoverySuccess: 'popups/errorLogin/SET_RECOVERY_SUCCESS'
      }),
      ...mapActions({
        loginUser: 'auth/login',
        oauthLoginUser: 'auth/oauthlogin',
        recoveryUser: 'auth/recovery',
        getOAuthUrl: 'auth/getoauthurl',
        getProjects: 'projects/getProjects'
      }),
      showPass() {
        this.password = false
      },
      hidePass() {
        this.password = true
      },
      async loginAccount() {
        if (!this.$v.$anyError) {
          this.loading = true;
          await this.loginUser({
            email: this.login,
            password: this.pass
          }).then((res) => {
            this.getProjects()
          }).catch((e) => {
            this.loading = false;
            this.showOverlay(true);
            this.showErrorLogin(true);
          });

          this.loading = false;
        }
      },
      async oAuthLoginAccount(provider, code) {
        this.loading = true;
        await this.oauthLoginUser({provider: provider, code: code})
          .then((res) => {
          }).catch((e) => {
            this.loading = false;
          });
        this.loading = false;
      },
      async recoveryAccount() {
        if (!this.$v.login.$error) {
          this.loading = true;
          await this.recoveryUser({
            email: this.login
          }).then((res) => {
          }).catch((e) => {
            this.loading = false;
            this.showOverlay(true);
            this.showErrorLogin(true);
          });
          this.loading = false;
        }
      },
      async oAuthGoogle() {
        this.loading = true;
        await this.getOAuthUrl('google')
        .then((res) => {
        }).catch((e) => {
            this.loading = false;
        });
        this.loading = false;
      }

    },
    computed: {
      auth() {
        return this.$store.state.auth;
      },
      get() {
        return this.$store.getters['auth/loggedIn'];
      },
      disableBtn() {
        return !this.login || !this.pass
      },
      disableBtnRecovery() {
        return !this.login
      }
    }
  }

</script>

<style lang="scss" scoped>
  .login-form {
    max-width: 340px;
    width: 100%;
    margin: auto auto 30px;
    background: white;
    box-shadow: 0px 4px 12px rgba(0, 82, 127, 0.2);
    border-radius: 8px;
  }

  .wrap-top {
    padding: 30px 0 31px;
    position: relative;
    display: flex;
    cursor: pointer;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      left: 0;
      bottom: 0;
      background: #F5F8FA;
      height: 1px;
    }

    img {
      max-width: 230px;
      margin: 0 auto;
    }
  }

  .wrap {
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .title {
    font-size: 18px;
    letter-spacing: 0.25px;
    margin-bottom: 30px;
  }

  .input-cont {
    margin-bottom: 10px;
    width: 100%;
  }

  .forgot-password {
    margin: 20px auto 30px;
    color: $lightBlue;
    text-decoration: underline;
    border: 1px solid white;

    &:focus {
      border: 1px solid $lightBlue;
    }
  }

  .or-wrap {
    position: relative;
    margin: 20px 0;
    display: flex;
    justify-content: center;

    &::before {
      content: '';
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0;
      background: $lightGrey;
      top:50%;
    }
  }

  .or-label {
    width: 60px;
    background: white;
    text-align: center;
    display: block;
    position: relative;
    font-size: 14px;
    letter-spacing: 0.25px;
    color: $darkBlue;
  }

  .auth2-list {
    display: flex;
    width: 100%;
    justify-content: space-between;
    justify-content: center;
  }

  .auth-item {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 10px;
    width: 33%;
    height: 50px;
    border-radius: 4px;
    transition: $anim;
    width: 100%;

    &:first-of-type {
      margin-left: 0;
    }

    &:last-of-type {
      margin-right: 0;
    }

    button {
      width: 100%;
      height: 100%;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-family: $msb;
      font-size: 14px;
      color: $darkBlue;


      svg {
        margin-right: 15px;
      }
      @include btnHover;
    }

    .fb-btn {
      background: #3B5998;
    }

    .google-btn {
      border: 1px solid $lightGrey;
    }

    .mail-btn {
      background: #168DE2;
    }
  }
</style>
